import React, { useContext, useEffect, useState } from "react";
import { RiArrowGoForwardFill, RiDownload2Line } from "react-icons/ri";
import { FiInbox } from "react-icons/fi";
import EngineeringLetter from "./EngineeringLetter";
import EngineeringAffidavit from "./EngineeringAffidavit";
import HelpText from "./HelpText";
import { message } from "antd";
import EngineeringConfirm from "../../../../components/Layout-Components/Editor-Layout/Modal/Modal-Content/EngineeringConfirm";
import EngineeringLoader from "../../../../components/Layout-Components/Editor-Layout/Modal/Modal-Content/EngineeringLoader";
import { downloadEngineeringData, getEngineeringData, updateEngineeringData, } from "../../../../services/engineeringService";
import { useViewerStore } from "../../../../store/store";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { MessageAlert } from "../../../../components";
import { logger } from "../../../../services/loggingService";
import updateImage from '../../../../assets/img/icons/update-icon.png';
import { AlertType, EnggAction, EnggSectionType } from "../../../../@types/enums";
import { EngineeringRoofData } from "../../../../@types/types";



const EngineeringSection = () => {
    const pathname = useViewerStore((state) => state.pathname);
    const isRoofChange = useViewerStore((state) => state.isRoofChange);
    const isEngineeringFieldsChange = useViewerStore((state) => state.isEngineeringFieldsChange);
    const isRefreshDone = useViewerStore((state) => state.isRefreshDone);
    const buildingListData = useViewerStore((state) => state.buildingListData);
    const masterDataList = useViewerStore((state) => state.masterDataList);
    const siteBuildingData = useViewerStore((state) => state.siteBuildingData);
    const siteDesignDetails = useViewerStore((state) => state.siteDesignDetails);
    const productType = useViewerStore((state) => state.productType);
    const [messageApi, contextHolder] = message.useMessage();
    const [type, setType] = useState<EnggSectionType>(EnggSectionType.EL);
    const { theme } = useContext(ThemeContext);
    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const [engData, setEngData] = useState<any>(undefined);
    const [dataloader, setDataloader] = useState(true);
    const [errorMessages, setErrorMessages] = useState<string[]>([]);
    const [isErrorMessage, setIsErrorMessage] = useState(false);

    const alertMessage = (type: AlertType, content: string) => {
        messageApi.open({
            //type:type,
            content: content,
            className:
                type === AlertType.error
                    ? "alertError"
                    : type === AlertType.success
                        ? "alertSuccess"
                        : "",
        });
    };

    const getLabelForValue = (value: number) =>
        masterDataList?.RafterSpace?.find(option => option.value === value)?.label ?? null;

    const getRoofList = () => {
        let newRoofListArray: EngineeringRoofData[] = []
        siteBuildingData.forEach((building) => {
            building.Roofs.forEach((roof) => {
                if (productType.includes('RRR') || productType.includes('R&R') || roof.Number_of_Modules > 0) {
                    const mappedRoof = {
                        Include_In_Letter: roof.Include_In_Letter,
                        Id: roof.Id,
                        Building_Name: building.Building_Name ?? "",
                        Name: roof.Name_Override ? `Roof ${roof.Name_Override}` : roof.Name ?? "",
                        Structure_Type_Name: masterDataList?.StructureType?.find((option) => option.value === roof.Structure_Type_Id)?.label || "",
                        Rafter_Size: roof.Rafter_Size ?? "",
                        Rafter_Space: Number(masterDataList?.RafterSpace?.find((option) => option.value === roof.Rafter_Space_Id)?.label) || 0,
                        Max_Span: roof.Max_Span ?? 0,
                        PSF: Number(masterDataList?.PSF?.find((option) => option.value === roof.PSF_Id)?.label) || 0,
                        Dead_Load: Number(masterDataList?.DeadLoad?.find((option) => option.value === roof.Dead_Load_Id)?.label) || 0,
                    };
                    newRoofListArray.push(mappedRoof);
                }
            });
        });

        return newRoofListArray
    }

    useEffect(() => {
        setDataloader(true);
        setEngData(undefined);
        useViewerStore.setState({
            isEngineeringFieldsChange: false,
            isRefreshDone: false,
            isRoofChange: false,
        });
        if (pathname.includes("engineering-letter")) {
            setType(EnggSectionType.EL);
        } else if (pathname.includes("engineering-affidavit")) {
            setType(EnggSectionType.FEA);
        }
    }, [pathname]);

    useEffect(() => {
        if (type) {
            setDataloader(true);
            getEngineeringDataHandler();
        }
    }, [type, siteDesignDetails]);

    const getEngineeringDataHandler = async () => {
        try {
            await getEngineeringData(handlePayload(EnggAction.Initial), EnggAction.Initial)
                .then((data) => {
                    if (data.hasOwnProperty("Opportunity_ID")) {
                        setEngData(data);
                    } else {
                        setIsErrorMessage(true);
                    }
                    setDataloader(false);
                })
                .catch((error) => {
                    logger.error(error, "err");
                    setDataloader(false);
                });
        } catch (error) {
            logger.error(error);
            setDataloader(false);
            // setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isErrorMessage) sceneViewer.viewerAlert({ show: false });
    }, [isErrorMessage]);

    const handlePayload = (action: EnggAction) => {
        const opId = sessionStorage.getItem("SalesForceId");
        let payload;
        if (action === EnggAction.Initial || action === EnggAction.Reset) {
            payload = {
                opportunity_ID: opId,
                account_ID: "",
                township_Account_ID: "",
                opportunity_Product_Category: "Solar",
                system_Size: 0,
                snow_Load: 0,
                snow_Load_Per: "",
                structure_Type: "",
                exposure_Category: "",
                wind_Criteria: 0,
                state_Code: "",
                modifications_Needed: "N",
                code_Override: "N",
                mounting_Bracket_Override: "",
                opportunity_Territory: "",
                installation_Type: "",
                roof_Loading_Override: "Y",
                title_Name: "",
                account_Billing_Street: "",
                account_Billing_City: "",
                account_Billing_State: "",
                account_Billing_PostalCode: "",
                customer_No: "",
                oneDRAW_Button: type === EnggSectionType.EL ? "EL" : "FEA",
                roof_List: getRoofList(),
                code: "",
                special_Structural_Notes: "",
                roof_Framing_Preview: "",
                roof_Loading_Preview: "",
                modifications_Preview: "",
                file_Name: "",
                code_Preview: "",
                mounting_Brackets_Preview: "",
                feA_Preview: "",
                code_Dropdown_Values: [],
                mounting_Bracket_Dropdown_Values: [],
                structure_Type_Dropdown_Values: [],
                dead_Load_Dropdown_Values: [],
                psF_Dropdown_Values: [],
                snow_Load_Per_Dropdown_Values: [],
                snow_Load_Dropdown_Values: [],
                wind_Criteria_Dropdown_Values: [],
                exposure_Category_Dropdown_Values: [],
                pdfOutputData: [
                    {
                        townshipName: "",
                        townshipStreet: "",
                        townshipAddress: "",
                        titleName: "",
                        billingStreet: "",
                        billingAddress: "",
                        content: "",
                        stamp: "",
                        footerContent: "",
                        currentDate: "",
                        customerNo: "",
                        licenseNo: "",
                        FileName: "",
                    },
                ],
            };
        } else if (action === EnggAction.Update) {
            payload = {
                opportunity_ID: opId,
                exposure_Category: engData?.Exposure_Category,
                wind_Criteria: engData?.Wind_Criteria,
                snow_Load: engData?.Snow_Load,
                snow_Load_Per: engData?.Snow_Load_Per,
                roof_Loading_Override: engData?.Roof_Loading_Override,
                modifications_Needed: engData?.Modifications_Needed,
                code: engData?.Code,
                mounting_Bracket_Override: engData?.Mounting_Bracket_Override,
            }
        } else {
            payload = {
                opportunity_ID: opId,
                account_ID: engData?.Account_ID,
                township_Account_ID: engData?.Township_Account_ID,
                opportunity_Product_Category: "Solar",
                system_Size: engData?.System_Size,
                snow_Load: engData?.Snow_Load,
                snow_Load_Per: engData?.Snow_Load_Per,
                structure_Type: engData?.Structure_Type,
                exposure_Category: engData?.Exposure_Category,
                wind_Criteria: engData?.Wind_Criteria,
                state_Code: engData?.State_Code,
                modifications_Needed: engData?.Modifications_Needed,
                code_Override: engData?.Code_Override,
                mounting_Bracket_Override: engData?.Mounting_Bracket_Override,
                opportunity_Territory: engData?.Opportunity_Territory,
                installation_Type: engData?.Installation_Type,
                roof_Loading_Override: engData?.Roof_Loading_Override,
                title_Name: engData?.Title_Name,
                account_Billing_Street: engData?.Account_Billing_Street,
                account_Billing_City: engData?.Account_Billing_City,
                account_Billing_State: engData?.Account_Billing_State,
                account_Billing_PostalCode: engData?.Account_Billing_PostalCode,
                customer_No: engData?.Customer_No,
                oneDRAW_Button: type === EnggSectionType.EL ? "EL" : "FEA",
                roof_List: engData?.Roof_List,
                code: engData?.Code,
                special_Structural_Notes: engData?.Special_Structural_Notes,
                roof_Framing_Preview: engData?.Roof_Framing_Preview,
                roof_Loading_Preview: engData?.Roof_Loading_Preview,
                modifications_Preview: engData?.Modifications_Preview,
                file_Name: engData?.File_Name,
                code_Preview: engData?.Code_Preview,
                mounting_Brackets_Preview: engData?.Mounting_Brackets_Preview,
                feA_Preview: engData?.FEA_Preview,
                code_Dropdown_Values: engData?.Code_Dropdown_Values,
                mounting_Bracket_Dropdown_Values:
                    engData?.Mounting_Bracket_Dropdown_Values,
                structure_Type_Dropdown_Values: engData?.Structure_Type_Dropdown_Values,
                dead_Load_Dropdown_Values: engData?.Dead_Load_Dropdown_Values,
                psF_Dropdown_Values: engData?.PSF_Dropdown_Values,
                snow_Load_Per_Dropdown_Values: engData?.Snow_Load_Per_Dropdown_Values,
                snow_Load_Dropdown_Values: engData?.Snow_Load_Dropdown_Values,
                wind_Criteria_Dropdown_Values: engData?.Wind_Criteria_Dropdown_Values,
                exposure_Category_Dropdown_Values: engData?.Exposure_Category_Dropdown_Values,
                pdfOutputData: engData?.PDFOutputData,
            };
        }
        return payload;
    };

    const handleEngineeringActions = async (type: EnggSectionType, action: EnggAction) => {
        let error = false;
        const newRoofListArray: EngineeringRoofData[] = [];
        if (action === EnggAction.Refresh || action === EnggAction.Download) {
            if (type === EnggSectionType.EL) {
                if (
                    engData?.Exposure_Category === "" ||
                    engData?.Exposure_Category === "0"
                ) {
                    error = true;
                    errorMessages.push("Exposure Category");
                }
                if (engData?.Wind_Criteria === 0) {
                    error = true;
                    errorMessages.push("Wind Criteria");
                }

                if (engData?.Snow_Load === 0) {
                    error = true;
                    errorMessages.push("Snow Load");
                }
                if (engData?.Snow_Load_Per === "") {
                    error = true;
                    errorMessages.push("Snow Load Per");
                }
                if (engData?.Code === "") {
                    error = true;
                    errorMessages.push("Code");
                }
                if (engData?.Mounting_Bracket_Override === "") {
                    error = true;
                    errorMessages.push("Mounting Bracket Override");
                }
            } else {
                if (engData?.Code === "") {
                    error = true;
                    errorMessages.push("Code");
                }
            }
        }
        if (error) {
            handleRequiredError(action);
        } else {
            if (action === EnggAction.Refresh || action === EnggAction.Download) {
                buildingListData.forEach((building) => {
                    building.Roofs.forEach((roof) => {
                        if (productType.includes('RRR') || productType.includes('R&R') || roof.Number_of_Modules > 0) {
                            const mappedRoof = {
                                Include_In_Letter: roof.Include_In_Letter,
                                Id: roof.Id,
                                Building_Name: building.Building_Name,
                                Name: roof.Name_Override ? `Roof ${roof.Name_Override}` : roof.Name ?? "",
                                Structure_Type_Name: roof.Structure_Type_Id
                                    ? roof.Structure_Type_Id === 4
                                        ? "Other"
                                        : engData.Structure_Type_Dropdown_Values[
                                        roof.Structure_Type_Id - 1
                                        ]
                                    : "",
                                Rafter_Size: roof.Rafter_Size ? roof.Rafter_Size : "0",
                                Rafter_Space: roof.Rafter_Space_Id
                                    ? Number(getLabelForValue(roof.Rafter_Space_Id))
                                    : 0,
                                Max_Span: roof.Max_Span,
                                PSF: roof.PSF_Id
                                    ? Number(engData.PSF_Dropdown_Values[roof.PSF_Id - 1])
                                    : null,
                                Dead_Load: roof.Dead_Load_Id
                                    ? Number(
                                        engData.Dead_Load_Dropdown_Values[roof.Dead_Load_Id - 1]
                                    )
                                    : null,
                            };
                            newRoofListArray.push(mappedRoof);
                        }
                    });
                });
                engData.Roof_List = newRoofListArray;
            }
            /***** Added when we dont require confirmation prompt***** */
            
            const confirmTitle = `${action === EnggAction.Refresh
                ? "Updating the "
                : action === EnggAction.Reset
                    ? "Reset the "
                    : "Download the "
                }${type === EnggSectionType.EL
                ? "Engineering letter"
                : "Final Engineering Affidavit"
            }`;

            // Only show confirmation modal for Download if there are unsaved changes
            if (
                action === EnggAction.Download &&
                (isRoofChange || (isEngineeringFieldsChange && !isRefreshDone))
            ) {
                sceneViewer.viewerAlert({
                    show: true,
                    title: confirmTitle,
                    message: (<EngineeringConfirm type={type}/>),
                    messageType: AlertType.success,
                    isModal: true,
                });
            } else {
                let errormessage = "";
                if (action === EnggAction.Refresh || action === EnggAction.Download) {
                    let otherStructureArr = newRoofListArray.filter(
                        (rf) => rf.Structure_Type_Name === "Other"
                    );
                    if (otherStructureArr.length > 0) {
                        errormessage =
                            'Please update the Structure Type on the Roofs, excluding the "Other" option';
                    }
                }
                if (errormessage !== "") {
                    alertMessage(AlertType.error, errormessage);
                } else {
                    useViewerStore.setState({ isSavingInProgress: true });
                    sceneViewer.viewerAlert({
                        show: true,
                        title: confirmTitle,
                        message: <EngineeringLoader action={action} />,
                        messageType: AlertType.success,
                        isModal: true,
                    });
                    await actionHandler(action);
                }
            }
        }
    };

    const handleRequiredError = (action: EnggAction) => {
        alertMessage(
            AlertType.error,
            `Please select ${errorMessages.join(
                errorMessages.length > 2 ? ", " : " and "
            )} before ${action}`
        );
        setErrorMessages([]);
    };

    const actionHandler = async (action: EnggAction) => {
        if (action === "Download") {
            //Filestream
            let modified_payload = handlePayload(EnggAction.Download);
            const updatePayload = handlePayload(EnggAction.Update);
            modified_payload.pdfOutputData = [];
            updateEngineeringData(updatePayload);
            useViewerStore.setState({ engDownloadProgress: 0 })
            await downloadEngineeringData(modified_payload,
                (progress: number) => useViewerStore.setState({ engDownloadProgress: progress })

            )
                .then((response) => {
                    if (response.status === 200) {
                        /***********Download the file ***********/
                        useViewerStore.setState({
                            isEngineeringFieldsChange: false,
                            isRoofChange: false,
                            isRefreshDone: false,
                        });

                        const fileName = modified_payload["file_Name"] + ".pdf";
                        const blob = new Blob([response.data], {
                            type: response.headers["content-type"],
                        });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", fileName);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);

                        sceneViewer.viewerAlert({ show: false });
                        useViewerStore.setState({ isSavingInProgress: false });
                    } else {
                        sceneViewer.viewerAlert({ show: false });
                        useViewerStore.setState({ isSavingInProgress: false });
                        alertMessage(AlertType.error, "Error while downloading the file");
                    }
                })
                .catch((error) => {
                    logger.error(error);
                    sceneViewer.viewerAlert({ show: false });
                    useViewerStore.setState({ isSavingInProgress: false });
                    alertMessage(AlertType.error, "Error while downloading the file");
                });
        } else {
            let modified_payload = handlePayload(action);
            await getEngineeringData(modified_payload, action)
                .then((response) => {
                    sceneViewer.viewerAlert({ show: false });
                    useViewerStore.setState({ isSavingInProgress: false });
                    if (response.hasOwnProperty("Opportunity_ID")) {
                        setEngData(response);

                        let actionText = action === EnggAction.Reset ? "resetted" : "updated";

                        let content = `The ${type === EnggSectionType.EL
                                ? "Engineering Letter data has been"
                                : "Final Engineering Affidavit data has been"
                            } ${actionText} successfully`;
                        alertMessage(AlertType.success, content);
                        if (!isRefreshDone && action === EnggAction.Refresh) {
                            useViewerStore.setState({
                                isRefreshDone: true,
                                isEngineeringFieldsChange: false,
                            });
                        }
                        if (action === EnggAction.Reset) {
                            useViewerStore.setState({
                                isRefreshDone: false,
                                isEngineeringFieldsChange: false,
                                isResetEdata: true,
                            });
                        }
                    } else {
                        alertMessage(AlertType.error, "Something went wrong. Please try later.");
                    }
                })
                .catch((error) => {
                    logger.error(error);
                    alertMessage(AlertType.error, "Something went wrong. Please try later.");
                });
        }
    };

    return (
        <>
            {contextHolder}
            {!dataloader && engData ? (
                <div className="tab__inner">
                    <div className="tab__title">
                        <span className="tab__title--text multi_tab_title">
                            <HelpText
                                tooltipkey={
                                    type === EnggSectionType.EL ? "engl-title" : "enga-title"
                                }
                            />
                            <span>
                                {type === EnggSectionType.EL
                                    ? "Engineering Letter"
                                    : "Final Engineering Affidavit"}
                            </span>
                            <RiDownload2Line
                                onClick={() => handleEngineeringActions(type, EnggAction.Download)}
                                size={20}
                                color="#69b1ff"
                                title="Download"
                            />
                            {(isEngineeringFieldsChange || isRoofChange) &&
                                !isRefreshDone && (

                                    <img title="Update" onClick={() => handleEngineeringActions(type, EnggAction.Refresh)} src={updateImage}
                                        className='updateIcon' id='updateEle' alt={"Updating"} />

                                )}

                            {isRefreshDone && (
                                <span style={{ transform: "rotate(180deg)" }}>
                                    {" "}
                                    <RiArrowGoForwardFill
                                        size={20}
                                        color="red"
                                        onClick={() => handleEngineeringActions(type, EnggAction.Reset)}
                                        title="Reset"
                                    />{" "}
                                </span>
                            )}
                        </span>
                    </div>
                    {type === EnggSectionType.EL ? (
                        <EngineeringLetter data={engData} setData={setEngData} />
                    ) : (
                        <EngineeringAffidavit data={engData} setData={setEngData} />
                    )}
                </div>
            ) : (
                <>
                    {dataloader ? (
                        <div className="tab_loader">
                            <span className="loader-icon-spinner"></span>{" "}
                            <p className={"theme-based-text-color"}>
                                {`Fetching ${type === EnggSectionType.EL
                                        ? "Engineering Letter"
                                        : "Final Engineering Affidavit"
                                    } Data.....`}
                            </p>
                        </div>
                    ) : (
                        <>
                            {isErrorMessage && (
                                <MessageAlert
                                    message="The Roof and Building Data isn't available for this customer. Please reach out to the Structural Team to complete their review."
                                    messageType="error"
                                    setState={setIsErrorMessage}
                                />
                            )}
                            <div className="empty_tab">
                                <FiInbox
                                    size={50}
                                    color={theme === "dark" ? "#ffffff" : "#000000"}
                                />
                                <br />
                                <p className={"theme-based-text-color"}>
                                    The Roof and Building Data isn't available for this customer.
                                    Please reach out to the Structural Team to complete their
                                    review.
                                </p>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default EngineeringSection;
